import { createFileRoute, redirect } from '@tanstack/react-router';
import { auth } from '@weebee/api';
import { AppShell } from '@/layouts/app-shell';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    await auth.authStateReady();
    if (!auth.currentUser) {
      throw redirect({ to: '/login' });
    }
    const tokenResult = await auth.currentUser.getIdTokenResult();
    if (tokenResult.claims['role'] !== 'admin') {
      throw redirect({ to: '/login', search: { error: 'unauthorized' } });
    }
  },
  component: AppShell,
});
